import React from 'react';
import ReactDom from 'react-dom';

class Modal extends React.Component{
    render(){
        return ReactDom.createPortal(
            <div className={"modal-back "+this.props.active}>
                <div className={"modal-inner "+(this.props.type ? this.props.type : "")} id={this.props.id} style={this.props.style}>
                    {this.props.children}
                </div>
            </div>,
            document.getElementById('modal-root')
        )
    }
}

export default Modal;
